import { useRef } from 'react';
import styled from 'styled-components';
import { BUTTON_SIZES, BUTTON_VARIANTS, ChatButton, IconButton } from 'ui/button';
import { useDrawerContext } from 'ui/fullScreen';
import { Hamburger, LongArrowLeft } from 'ui/icons';
import { QuickNav } from 'modules/quickNav';
import { colors, smallShadow, spacing } from 'ui/theme';
import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';

import { ViewSwitchToggle } from './Controls';
import { ContentNameInput } from './Controls/ContentNameInput';
import { useQueryParamContext } from '../context/QueryParamContext';
import { TemplateEditViews } from './types';

// header for Preview with Data

const HeaderContainer = styled.div<{ navBarHeight: number }>`
  align-items: center;
  display: flex;
  height: ${({ navBarHeight }) => `${navBarHeight}px`};
  padding: 0 ${spacing.threeQuarter};
  ${smallShadow};
  > * + * {
    margin-left: ${spacing.threeQuarter};
  }
`;

const TitleContainer = styled.div`
  flex: 1 1 auto;
  margin-left: ${spacing.plusQuarter};
`;

const ControlContainer = styled.div`
  column-gap: ${spacing.threeEights};
  display: flex;
  flex: 0 0 auto;
`;

const StyledQuickNav = styled(QuickNav)<{ navBarHeight: number }>`
  left: 0;
  margin-left: 0;
  top: ${({ navBarHeight }) => `${navBarHeight}px`};
`;

const StyledIconButton = styled(IconButton)`
  && {
    path {
      stroke: ${colors.link};
    }

    :hover {
      path {
        stroke: ${colors.link};
      }
    }
  }
`;

export const ViewHeader = () => {
  const { setView } = useQueryParamContext();
  const { isNavOpen, toggleNav } = useDrawerContext();
  const navBarHeight = useNavBarHeight();
  const navTrigger = useRef(null);

  return (
    <HeaderContainer navBarHeight={navBarHeight}>
      <IconButton onClick={() => toggleNav()} ref={navTrigger} variant={BUTTON_VARIANTS.GHOST}>
        <Hamburger color={colors.link} />
      </IconButton>
      <StyledIconButton
        onClick={() => setView(TemplateEditViews.settings)}
        variant={BUTTON_VARIANTS.GHOST}
      >
        <LongArrowLeft color={colors.link} />
      </StyledIconButton>
      <TitleContainer>
        <ContentNameInput isCompact />
      </TitleContainer>
      <ChatButton size={BUTTON_SIZES.LARGE} variant={BUTTON_VARIANTS.GHOST} />
      <ControlContainer>
        <ViewSwitchToggle />
      </ControlContainer>
      <StyledQuickNav
        navBarHeight={navBarHeight}
        isVisible={isNavOpen}
        triggerEl={navTrigger}
        toggleNav={toggleNav}
      />
    </HeaderContainer>
  );
};
